import { Context } from '../Reducers/Store';
import React, { useEffect, useState, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import NavMenu from '../Components/NavMenu';
import Toasts from '../Components/Toasts';
import { useMediaQuery } from 'react-responsive';
import Loading from '../Components/Loading';
import Sidebar from '../Components/Sidebar';
import '../Assets/Css/mobile-detection.css';

const Layout = () => {
  const [state, dispatch] = useContext(Context);
  const [expanded, setExpanded] = useState(
    localStorage.getItem('sidebar') === 'true'
  );
  const isTabletOrMobile = useMediaQuery({ maxWidth: 1224 });
  const [isMobile, setIsMobile] = useState(false);

  // Handle Sidebar Toggle
  const handleExpand = () => {
    const newState = !expanded;
    setExpanded(newState);
    localStorage.setItem('sidebar', newState);
  };

  useEffect(() => {
    if (
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      setIsMobile(true);
    }
  }, [0]);

  useEffect(() => {
    setExpanded(localStorage.getItem('sidebar') == 'true');
  }, [0]);

  useEffect(() => {
    window.intercomSettings = {
      api_base: 'https://api-iam.intercom.io',
      app_id: 'noi2o7hz',
    };

    (function () {
      var w = window;
      var ic = w.Intercom;
      if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
      } else {
        var d = document;
        var i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        var l = function () {
          var s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://widget.intercom.io/widget/noi2o7hz';
          var x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        };
        if (document.readyState === 'complete') {
          l();
        } else if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    })();
  }, []);

  return (
    <div className='App'>
      {/* Sidebar */}
      {state.isLogged && state.profile?.subscription?.role && (
        <Sidebar
          expanded={!isTabletOrMobile && expanded}
          setExpanded={handleExpand}
        />
      )}

      {/* Sidebar Toggle Button */}
      <button className='sidebar-toggle-btn' onClick={handleExpand}>
        {expanded ? '<<' : '>>'}
      </button>

      {/* Navigation Menu */}
      <NavMenu
        style={{
          paddingTop: 20,
          paddingLeft: expanded && !isTabletOrMobile ? 300 : 90,
          transition: 'all 0.3s ease-in-out',
        }}
      />

      {/* Main Content */}
      <div
        className='custom-container'
        style={{
          paddingTop: 20,
          paddingLeft: expanded && !isTabletOrMobile ? 300 : 90, // Ensure chat content shifts properly
          transition: 'all 0.3s ease-in-out',
        }}>
        <div className='main-content'>
          <Outlet />
        </div>
      </div>

      <Toasts />
      <Loading />

      {/* Mobile Warning */}
      {isMobile && (
        <div id='mobile-detection'>
          <div className='logo-monkey-message'></div>
          <p>Thank you for visiting our product. </p>
          <p>
            Currently, SocialChimp is available on computers and iPads only. Our
            mobile app will be available soon for a better mobile experience.
          </p>
          <p>Stay tuned for updates on the mobile app launch!</p>
          <a className='back-website' href='https://socialchimp.ai'>
            Go Back To Website
          </a>
        </div>
      )}
    </div>
  );
};

export default Layout;
